import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import ModalComponent from 'components/common/ModalComponent'
import ButtonComponent from 'components/common/ButtonComponent'
import { showAlert } from 'services/alerts.service'
import { makeRequest } from 'services/request.service'

import { useAuth } from 'auth/AuthContext'

const UploadWorkersModal = ({ isOpen, onClose }) => {
  const { user } = useAuth()
  const { t } = useTranslation()
  const [selectedFile, setSelectedFile] = useState(null)
  const [error, setError] = useState('')

  const handleFileChange = (e) => {
    const file = e.target.files[0]
    if (file) {
      const fileType = file.type
      if (fileType !== 'text/csv' && !file.name.endsWith('.csv')) {
        setError(t('mgmt.uploadWorkers.invalidCsv'))
        setSelectedFile(null)
      } else {
        setError('')
        setSelectedFile(file)
      }
    }
  }

  const handleSubmit = async () => {
    if (!selectedFile) {
      setError(t('mgmt.uploadWorkers.noFile'))
      return
    }

    const formData = new FormData()
    formData.append('file', selectedFile)

    try {
      await makeRequest({
        method: 'POST',
        url: `/management/workers-management/import/${user.farmId}`,
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${localStorage.getItem('secret')}`
        },
        alertResult: true
      })
      showAlert({ title: t('mgmt.uploadWorkers.successTitle'), html: t('mgmt.uploadWorkers.successMsg'), icon: 'success' })
      setSelectedFile(null)
      setError('')
      onClose()
    } catch (err) {
      console.error('Upload Error:', err)
      setError(t('mgmt.uploadWorkers.failMsg'))
    }
  }

  const customFooter = (
    <>
      <ButtonComponent type='button' customColorsStyles='bg-gray-100 text-greenPrimary hover:text-white' onClick={onClose}>{t('mgmt.common.close')}</ButtonComponent>
      <ButtonComponent type='submit' className='bg-greenPrimary text-white'>{t('mgmt.uploadWorkers.upload')}</ButtonComponent>
    </>
  )

  return (
    <ModalComponent 
      title={t('mgmt.uploadWorkers.title')} 
      isOpen={isOpen} 
      onClose={onClose} 
      customFooter={customFooter}
      onSave={handleSubmit}
    >
      <div className='space-y-4'>
        <div>
          <input type='file' accept='.csv' onChange={handleFileChange} />
          {error && <p className='text-red-600'>{error}</p>}
        </div>
      </div>
    </ModalComponent>
  )
}

export default UploadWorkersModal
